import { Link } from "@mixitone/components";
import DownloadIcon from "@mixitone/icons/download.svg";
import { desktopAppDownloadUrl } from "lib/desktopAppDownload";

const DesktopAppLink = () => (
  <Link
    kind="topNav"
    href={desktopAppDownloadUrl}
    target="_blank"
    rel="noreferrer"
    className="hidden text-white hover:text-slate-200 @sm/app:inline-flex"
    style={{ height: "var(--mixitone-header-height)" }}
    title="Offline sessions, NFC check-in, and automatic sync"
    aria-label="Download desktop app"
    data-testid="desktop-app-download"
  >
    <DownloadIcon className="h-5 w-5 text-white" />
  </Link>
);

export default DesktopAppLink;
